import moment from 'moment'
export default {
  setPatients(state, payload) {
    state.patients = payload
  },
  setVisits(state, payload) {
    state.visits = Array.isArray(payload) ? payload : []
    const firstVisit = state.visits[0]
    if (firstVisit) {
      state.selectedVisit = {
        id: firstVisit.id,
        selected: true,
        title: `${String(firstVisit.drFirstName || '')[0] || ''}${String(firstVisit.drLastName || '')[0] || ''}`,
        date: moment(firstVisit.date).format('YYYY-MM-DD'),
        description: firstVisit.description,
        checkUps: firstVisit.checkUps || []
      }
    } else {
      state.selectedVisit = null
    }
  },
  setCalendarSlots(state, payload) {
    state.calendarSlots = payload
  },
  setVisitVisibility(state, { isVisible, id, type }) {
    state[`${type}s`] = state.visits.map((el) => {
      if (el.id === id) {
        el.isVisible = isVisible
      }
      return el
    })
  },
  setPatient(state, payload) {
    state.patient = payload
  },
  setSelectedVisit(state, payload) {
    state.selectedVisit = payload
  },
  setSelectedVisitByVisible(state) {
    state.selectedVisit =
      (Array.isArray(state.visits) ? state.visits : []).find((el) => el.isVisible) ||
      (Array.isArray(state.checkUps) ? state.checkUps : []).find((el) => el.isVisible)
  },
  setFilters(state, payload) {
    state.filters[payload.prop] = payload.value
  },
  setCheckUps(state, payload) {
    state.checkUps = Array.isArray(payload) ? payload : []
  },
  setPrescriptions(state, payload) {
    state.prescriptions = Array.isArray(payload) ? payload : []
  },
  setVisitDates(state, payload) {
    state.visitDates = payload
  },
  setVisitDate(state, payload) {
    state.selectedVisitDate = payload
  },
  setVisitCheckups(state, payload) {
    state.visitCheckups = Array.isArray(payload) ? payload : []
  },
  setCheckUpsChange(state) {
    state.checkUpsChange = !state.checkUpsChange
  },
  setServices(state, payload) {
    state.services = Array.isArray(payload) ? payload : []
  },
  setVisitServices(state, payload) {
    state.visitServices = Array.isArray(payload) ? payload : []
  },
  addVisitService(state, payload) {
    if (!Array.isArray(state.visitServices)) state.visitServices = []
    state.visitServices.push(payload)
  },
  setPlannedPatientId(state, payload) {
    state.plannedPatientId = payload
  },
  setHasCertPassword(state, payload) {
    state.hasCertPassword = payload
  },
  setReferrals(state, payload) {
    state.referrals = Array.isArray(payload) ? payload : []
  },
  setProcedures(state, payload) {
    state.procedures = Array.isArray(payload) ? payload : []
  }
}
